import {
  Button,
  Row,
  Typography,
} from "../../common/utils/antd-imports/AntdImports";
import { ReactComponent as NotFoundImage } from "../../../assests/not-found-image.svg";
import "./NotFoundPage.css";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
const NotFoundPage = () => {
  const { Text } = Typography;
  const userRole = useSelector((state) => state.login.userType);
  const navigate = useNavigate();
  const handleGoBack = () => {
    if (userRole === "owner") {
      navigate("/seller/dashboard");
    } else {
      navigate("/home");
    }
  };
  return (
    <div className="not-found-page-container">
      <div className="main">
        <Row>
          <NotFoundImage className="not-found-image" />
        </Row>
        <Row className="oops-page-text-header-row">
          <Text className="oops-page-text-header">
            Oops! This page doesn’t exist.
          </Text>
        </Row>
        <Row className="page-not-found-paragraph-row">
          <Text className="page-not-found-paragraph-text">
            The link you followed may be broken, or the page may have been
            removed. Don’t worry — you’re still in AMP!
          </Text>
        </Row>
        <Row className="go-back-page-not-button">
          <Button
            type="primary"
            htmlType="submit"
            className="signup-button billboard-button-2"
            onClick={handleGoBack}
          >
            {userRole === "owner" ? "Go to Dashboard" : "Go to Home"}
          </Button>
        </Row>
      </div>
    </div>
  );
};
export default NotFoundPage;
